import {useEffect} from 'react';

/**
 * Hook that will listen for click events in the document when enabled.
 * On click will call the callback when enabled
 * @param enabled Enabled true/false
 * @param callback Callback to call when clicked.
 */
export const useDocumentClickListener = (
  enabled: boolean,
  callback: (this: Document, ev: MouseEvent) => void,
) => {
  useEffect(() => {
    if (enabled) {
      document.addEventListener('click', callback);
    } else {
      document.removeEventListener('click', callback);
    }
    return () => document.removeEventListener('click', callback);
  }, [callback, enabled]);
};
